module.exports = __webpack_public_path__ + "static/media/206-gallery01.f2398aba.jpg";